import * as React from 'react';
import { SVGProps } from 'react';

const SvgSportsMedicine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M22.301 30.76c1.36.316 2.75.478 4.145.486.945.001 1.888-.085 2.818-.258 1.857-.343 3.647-1.024 5.633-2.144 2.028-1.145 2.531-2.658 2.595-3.727.113-1.868-1.035-3.586-2.221-4.46-1.4-1.033-3.554-1.212-5.455-1.37h-.01l-.01-.001c-.697-.058-1.349-.111-1.82-.2-1.372-.262-5.656-3.31-7.065-4.314-.184-.132-.35-.247-.481-.34-.443-.314-.489-.632-.434-1.73a8.458 8.458 0 0 0-.013-1.45 2.45 2.45 0 0 0-.975-1.687c-1.365-1.044-3.625-.839-4.54-.701-2.207.328-3.299 1.446-5.26 3.92-.871 1.102-1.608 1.188-2.625 1.307H6.58c-.813.095-1.721.19-2.658.847-.937.658-1.157 1.417-1.176 1.94a2.568 2.568 0 0 0 .586 1.662c-.491.757-1.044 1.986-1.344 3.908-.553 3.542 1.024 5.343 2.64 6.636 2.026 1.624 4.923 1.899 6.273 1.692.831-.128 1.71-.775 2.953-1.746l.026-.02c.341-.266.81-.631 1.088-.807.177.072.439.19.677.3A31.095 31.095 0 0 0 22.3 30.76Z" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M22.301 30.76c1.36.316 2.75.478 4.145.486.945.001 1.888-.085 2.818-.258 1.857-.343 3.647-1.024 5.633-2.144 2.028-1.145 2.531-2.658 2.595-3.727.113-1.868-1.035-3.586-2.221-4.46-1.4-1.033-3.554-1.212-5.455-1.37h-.01l-.01-.001c-.697-.058-1.349-.111-1.82-.2-1.372-.262-5.656-3.31-7.065-4.314-.184-.132-.35-.247-.481-.34-.443-.314-.489-.632-.434-1.73a8.458 8.458 0 0 0-.013-1.45 2.45 2.45 0 0 0-.975-1.687c-1.365-1.044-3.625-.839-4.54-.701-2.207.328-3.299 1.446-5.26 3.92-.871 1.102-1.608 1.188-2.625 1.307H6.58c-.813.095-1.721.19-2.658.847-.937.658-1.157 1.417-1.176 1.94a2.568 2.568 0 0 0 .586 1.662c-.491.757-1.044 1.986-1.344 3.908-.553 3.542 1.024 5.343 2.64 6.636 2.026 1.624 4.923 1.899 6.273 1.692.831-.128 1.71-.775 2.953-1.746l.026-.02c.341-.266.81-.631 1.088-.807.177.072.439.19.677.3A31.095 31.095 0 0 0 22.3 30.76Z"
    />
    <path
      fill="currentColor"
      d="M18.072 17.595a.784.784 0 0 1-.062-1.567l2.952-.226a.784.784 0 0 1 .12 1.563l-2.952.228-.058.002Z"
    />
    <path
      fill="currentColor"
      d="M20.813 20.136a.797.797 0 0 1-.438-.134.783.783 0 0 1-.33-.807l.637-3.151a.784.784 0 0 1 1.537.312l-.638 3.151a.785.785 0 0 1-.768.63Zm2.767 1.746a.785.785 0 0 1-.618-1.27l1.788-2.257a.784.784 0 1 1 1.233.97l-1.788 2.258a.784.784 0 0 1-.616.3Z"
    />
    <path
      fill={props.fill}
      d="M18.854 19.213v4.845l-6.63.024-4.877-4.869h11.507Z"
    />
  </svg>
);

export default SvgSportsMedicine;
